import { Component, ComponentFactoryResolver, OnInit, ViewContainerRef } from '@angular/core';
import {  ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { Subscription } from 'rxjs';
import { setPageNumber } from 'app/App Store/actions/pageChange.actions';
import { Store } from '@ngrx/store';
import { AppState } from 'app/App Store/state';
@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss',
  "../../../../../../assets/sass/libs/datatables.scss",],
  encapsulation: ViewEncapsulation.None,
})
export class ListComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 100,
    totalPages:0
  };
  // row data
  searchByName=''
  searchVal=null
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue=''
  isFilter:boolean=false
  // column header
  public columns = [
    { name: " Name", prop: "name" },
    { name: "Website", prop: "website" },
    { name: "Type", prop: "type" },
    { name: "Status", prop: "is_activated" },
    { name: "Actions", prop: "Actions" },
  ];

  // private
  private tempData = []; 
  imageUrl=environment.apiUrls.imageUrl;

  business_id:any
  isActivated:boolean
  @ViewChild('name') inputName;
  user_role:any
  row_name:any
  row_ref:any
  row_contacts=[]

  guideline_data:any
  pageNumberSubscription : Subscription

  constructor(public apiService:ApiService,
             private spinner: NgxSpinnerService,  
              public toastr: ToastrService,
              private modalService: NgbModal,private router:Router,
              private activatedRoute: ActivatedRoute,private store: Store<AppState> ) {

              this.user_role=JSON.parse(localStorage.getItem('user'))
              let setting_data = JSON.parse(localStorage.getItem('setting-record'))
              let key_data = setting_data.filter((item) => item.key == 'Business') 
              this.guideline_data = key_data[0]?._id

              this.activatedRoute.queryParamMap.subscribe((params) => {
                let page = +params.get('page');
                this.setPage(page)
              });
              this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
              .subscribe(pageNumber => {
                this.page.pageNumber = pageNumber;
                if(pageNumber !==undefined){
                  this.page.pageNumber = pageNumber ?  pageNumber-1 :0
                }
              });
              
            }

  ngOnInit(): void {
    this.getAllBusinessList()
  }
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
activateBusiness(data){
  var id=data._id
  this.isActivated=data.is_activated =!data.is_activated

  let model={
    is_activated:this.isActivated
  }
  this.apiService.updateBusiness(id,model).subscribe((res: any) => {
    if (res.isSuccess) {
      this.toastr.success(res.message)
      this.getAllBusinessList()
    }
  })
}
  getAllBusinessList(){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getBusinessList(this.page.pageNumber +1,this.limitRef).subscribe((res:any)=>{
      this.spinner.hide();
      this.rows =res.data.items
      this.page.totalPages=res.data.totalCount
    })
  }
  pageChangeData(page:any) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { page: page.offset +1 },
      queryParamsHandling: 'merge' // keep existing query params
    });
    this.apiService.getBusinessList(page.offset +1,this.limitRef).subscribe((res:any)=>{
      this.setPage(page.offset +1)
      this.rows =res.data.items
      this.page.totalPages=res.data.totalCount
    }) 
  }
  getBusinessFilter(data:any){
    this.searchByName = data 
      this.apiService.getBusinessSearch(this.searchByName).subscribe((res:any)=>{
        this.rows =res.data
      })
    
  }
  // getFilterStudent(data:any){ 
  //   this.searchByName = data 
  //   console.log('=>>',this.searchByName)
  //   this.apiService.getStudentBySearch(this.page.pageNumber+1,100,this.searchByName).subscribe((res:any)=>{
  //     this.rows =res?.items
  //     this.page.totalPages=res.total
  //     console.log('student filter ==',res) 
  //   })
  // }


  resetFilter(){
    this.inputName.nativeElement.value=null
    this.getAllBusinessList()
  }
  // Public Methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * filterUpdate
   *
   * @param event
   */
   filterUpdate(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.tempData.filter(function (d) {
      return d.Username.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
    this.filterRows=temp
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  /**
   * updateLimit
   *
   * @param limit
   */
  updateLimit(limit) {
    this.limitRef = limit.target.value;
    this.apiService.getBusinessList(1,this.limitRef).subscribe((res:any)=>{
    })
  }
 
  editBusiness(id:any){
  }
  deleteBusiness(){
    if(this.business_id){
      this.apiService.deleteBusiness(this.business_id).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.getAllBusinessList()
        }
        else{
          this.toastr.error(res.error)
        } 
        })
    }
    else{
      this.toastr.error('something went wrong !!')
    }
  }

   // ================== Delete Alert ========================
   ConfirmColor(id:any) {
    this.business_id=id
    swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: 'Yes, delete it!',
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then( (result)=> {
      if (result.value) {  
        this.deleteBusiness()      
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your imaginary file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your imaginary file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  
  // ==========================================
  openModal(content,name,ref){
    this.row_name=name
    this.row_ref = ref
    const modalRef = this.modalService.open(content);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  addContact(id){
    window.open(`/contact/add?id=${id}`, '_blank');
  }
  openContactModal(content,data){
    this.row_contacts =[]
    this.row_contacts= data?.contact
    this.row_name = data?.name
    const modalOptions: NgbModalOptions = {
      size: 'lg' 
    };
    const modalRef = this.modalService.open(content,modalOptions);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  updateContact(id){
    const urlToOpen = `/contact/edit/${id}`;
    window.open(urlToOpen, '_blank');
  }
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
}
